<template>
    <div id="app">
        <Header />

        <main>
            <Home />
        </main>

        <Footer />
    </div>
</template>

<script>
    import Home from './components/Home.vue';
    import Header from './components/block/header/Header.vue';
    import Footer from './components/block/header/Footer.vue';

    export default {
        name: 'app',
        components: {
            Home,
            Header,
            Footer,
        },
        beforeRouteUpdate(to, from, next) {
            this.validateRoute(to)
            next()
        }
    };
</script>

<style type="text/css">
    @import "./assets/stylesheets/style.css";
</style>